import { faInstagram } from "@fortawesome/free-brands-svg-icons"
import { faEnvelope  } from '@fortawesome/free-solid-svg-icons'
import { faLinkedin } from "@fortawesome/free-brands-svg-icons"
const CArray = [
    {
        icon:faEnvelope,
        messageh5: "Email",
        messagep:"rahmanfaisal516@gmail.com"

    },
    {
        icon:faInstagram,
        messageh5: "Instagram",
        messagep:"@faisalrahman557"

    },
    {
        icon:faLinkedin,
        messageh5: "LinkedIn",
        messagep:"faisal rahman"

    },
]

export default CArray;